var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 2.76753C1.5 2.43142 1.6317 2.10908 1.86612 1.87142C2.10054 1.63376 2.41848 1.50024 2.75 1.50024H15.25C15.5815 1.50024 15.8995 1.63376 16.1339 1.87142C16.3683 2.10908 16.5 2.43142 16.5 2.76753V4.52989C16.4999 4.978 16.3242 5.40771 16.0117 5.72452L11.5 10.2986V16.5708C11.5 16.7292 11.4601 16.885 11.384 17.0234C11.3079 17.1618 11.1982 17.2781 11.0653 17.3614C10.9324 17.4447 10.7806 17.4922 10.6245 17.4993C10.4684 17.5064 10.3131 17.473 10.1733 17.4021L7.07583 15.8324C6.90281 15.7447 6.75729 15.6098 6.65559 15.443C6.55388 15.2762 6.50001 15.0839 6.5 14.8878V10.2986L1.98833 5.72452C1.67575 5.40771 1.50009 4.978 1.5 4.52989V2.76753ZM3.16667 3.18995V4.52989L7.8 9.22729C7.91621 9.34495 8.0084 9.48468 8.07132 9.63849C8.13423 9.7923 8.16663 9.95717 8.16667 10.1237V14.4958L9.83333 15.3407V10.1237C9.83333 9.78743 9.965 9.46469 10.2 9.22813L14.8333 4.52905V3.18995H3.16667Z",
    fill: "#1976D2",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchFilter);
export default __webpack_public_path__ + "static/media/switch_filter.e4ddea099450024c8431a08df2f7a61a.svg";
export { ForwardRef as ReactComponent };